module.exports = __webpack_public_path__ + "img/default.3188a360.png";